<template>
  <v-autocomplete
    outlined
    dense
    hide-details="auto"
    :items="time_slots"
    :label="label"
    v-model="time"
    :rules="requiredRules"
    auto-select-first
    clearable
    :filter="search"
    :disabled="disabled"
  ></v-autocomplete>
</template>

<script>
import validator from "@/helper/validator";
export default {
  data: () => ({
    menu: false,
    time_slots: [],
  }),
  props: ["value", "label", "no_required", "disabled"],
  computed: {
    requiredRules: function() {
      if (this.no_required) return [];
      else return [validator.required];
    },
    time: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    search(item, input) {
      const cleaned_item = item.replace(/\D/g, "");
      const cleaned_input = input.replace(/\D/g, "");
      return cleaned_item.includes(cleaned_input);
    },
  },
  created() {
    let ret = [];
    for (let i = 7; i <= 22; i++) {
      for (let j = 0; j <= 59; j += 5) {
        let text = "";

        if (i < 10) text += "0";
        text += i.toString();

        text += ":";

        if (j < 10) text += "0";
        text += j.toString();

        if (!(i === 22 && j > 30)) ret.push(text);
      }
    }
    this.time_slots = ret;
  },
};
</script>
